import { render, staticRenderFns } from "./Cribs.vue?vue&type=template&id=0abeab7c"
import script from "./Cribs.vue?vue&type=script&lang=ts"
export * from "./Cribs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports